import * as _ from 'lodash';
import { Component, Input, Output } from '@angular/core';
import { finalize, first, takeUntil } from 'rxjs/operators';

import { ServiceItems, ServicePages, ServiceExpertises, ServiceErrors, ServiceTextAnalyser } from '@services';
import { Page, Member } from '@models';
import { LinkedItemsComponent } from '../linked-items.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'expertises',
    templateUrl: './expertises.component.html',
    styleUrls: ['./expertises.component.scss']
})
export class ExpertisesComponent extends LinkedItemsComponent {

    private _member: Member;
    @Input()
    set member(value: Member) {
        this._member = value;
        this.handleEditionMode(this._editionMode);
    }
    get member(): Member {
        return this._member;
    }

    constructor(
        private servicePages: ServicePages,
        private serviceItems: ServiceItems,
        private serviceErrors: ServiceErrors,
        private serviceExpertises: ServiceExpertises,
        protected serviceTextAnalyser: ServiceTextAnalyser
    ) {
        super(servicePages, serviceTextAnalyser);
        this.field = 'expertises';
    }

    protected handleOrder(orderDirection: 'asc' | 'desc') {
        if (this._member instanceof Member) {
            this._member.expertises = this.servicePages.sortArray(this._member.expertises, orderDirection);
        }
    }

    protected handleEditionMode(value: boolean) {
        if (this._member instanceof Member) {
            this.isCreation = _.isUndefined(this._member.id);
            this.canEdit = this.serviceExpertises.userCanModifyExpertises(this._member);
            if (value === true && this.canEdit === true) {
                this.loadAllPotentialLinkedItems<Page>(this._member.expertises, this._member);
            }
        }
    }

    addLinkedItem(page: Page) {
        page.isLoading = true;
        this.ctrl.reset();
        this.ctrl.disable();
        this.actionInProgress = true;

        let expertises = this._member.expertises;
        expertises.push(page);
        expertises = this.servicePages.sortArray(expertises, 'asc');
        this._member.expertises = expertises;

        if (!this.isCreation) {
            this.serviceExpertises.addExpert(page, this._member).pipe(
                finalize(() => {
                    this.ctrl.enable();
                    this.actionInProgress = false;
                    this.newLinkInput.nativeElement.focus();
                }),
                first(),
                takeUntil(this._destroyed$)
            ).subscribe(
                () => {
                    page.isLoading = false;
                    _.remove(this.allPotentialLinkedItems, function(o: Page) { return o.id === page.id; });

                    this._member.expertises = expertises;
                    if (this._member.witness) {
                        this._member.witness.expertises = expertises;
                    }
                    this.serviceItems.item = this._member;
                },
                (error: HttpErrorResponse) => {
                    _.remove(this._member.expertises, function(o: Page) { return o.id === page.id; });

                    this.serviceErrors.handleError('ITEM.EXPERTS.ADD', error);
                });
        } else {
            page.isLoading = false;
            _.remove(this.allPotentialLinkedItems, function(o: Page) { return o.id === page.id; });
            this.ctrl.enable();
            this.actionInProgress = false;
            this.newLinkInput.nativeElement.focus();
        }
    }

    removeLinkedItem(page: Page) {
        page.isLoading = true;
        page.isUserExpert = true;
        this.ctrl.disable();
        this.actionInProgress = true;
        if (!this.isCreation) {
            this.serviceExpertises.removeExpert(page, this._member).pipe(
                finalize(() => {
                    page.isLoading = false;
                    this.ctrl.enable();
                    this.actionInProgress = false;
                }),
                first(),
                takeUntil(this._destroyed$)
            ).subscribe(
                () => {
                    this.allPotentialLinkedItems.push(page);

                    const expertises = this._member.expertises;
                    _.remove(expertises, function(o: Page) { return o.id === page.id; });

                    this._member.expertises = expertises;
                    if (this._member.witness) {
                        this._member.witness.expertises = expertises;
                    }
                    this.serviceItems.item = this._member;
                },
                (error: HttpErrorResponse) => {
                    let expertises = this._member.expertises;
                    expertises.push(page);
                    expertises = this.servicePages.sortArray(expertises, 'asc');

                    this._member.expertises = expertises;
                    if (this._member.witness) {
                        this._member.witness.expertises = expertises;
                    }
                    this.serviceItems.item = this._member;

                    this.serviceErrors.handleError('ITEM.EXPERTS.REMOVE', error);
                }
            );
        } else {
            this.allPotentialLinkedItems.push(page);
            _.remove(this._member.expertises, function(o: Page) { return o.id === page.id; });
            page.isLoading = false;
            this.ctrl.enable();
            this.actionInProgress = false;
        }
    }
}
